<div class="column">
  @if (!hasRoundedCorners) {
    <div
      class="row justify-start align-items-center switch-elements"
      [style.width.rem]="switchContainerWidth"
      >
      @for (switchElement of _switchElements; track switchElement) {
        <div
          class="item grow switch-element"
          [class.selected]="switchElement.isSelected"
          (click)="selectElement(switchElement)"
          >
          <div class="row grow center-center">
            {{ switchElement.name }}
          </div>
        </div>
      }
    </div>
  }
  @if (hasRoundedCorners) {
    <div
      class="row justify-start align-items-center switch-elements-rounded-corners"
      [style.width.rem]="switchContainerWidth"
      >
      @for (switchElement of _switchElements; track switchElement) {
        <div
          class="item grow switch-element-rounded-corners"
          [ngClass]="{'selected-rounded-corners': switchElement.isSelected}"
          (click)="selectElement(switchElement)"
          >
          <div class="row grow center-center">
            {{ switchElement.name }}
          </div>
        </div>
      }
    </div>
  }
</div>
